package com.exura.features.plandefinition.domain.model.series

import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Base implementation of BaseSeries for series that are anchored to a specific day.
 *
 * @param E The type of plan element this series generates
 */
abstract class BaseAnchoredSeries<E : BasePlanElement>(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val seriesSpawnType: SeriesSpawnType,
) : BaseSeries<E> {
    abstract override val title: String
    abstract override val description: String
    abstract override val elements: List<E>
    abstract override val imageUrl: String?
    abstract override val relativeDay: Int
}
